import React from 'react';

const Icons = {
  CSHARP: require('../assets/c-sharp-plain.svg') as string,
  WEB_DEVELOPMENT: require('../assets/html5-plain.svg') as string,
  ANDROID: require('../assets/android-plain.svg') as string,
  AWS: require('../assets/aws-plain.svg') as string,
  C: require('../assets/c-plain.svg') as string,
  CSS: require('../assets/css-plain.svg') as string,
  CLOJURE: require('../assets/clojure-plain.svg') as string,
  CPLUSPLUS: require('../assets/cplusplus-plain.svg') as string,
  DOTNET: require('../assets/dot-net-plain.svg') as string,
  FLUTTER: require('../assets/flutter-plain.svg') as string,
  GOLANG: require('../assets/golang-plain.svg') as string,
  HASKELL: require('../assets/haskell-plain.svg') as string,
  KOTLIN: require('../assets/kotlin-plain.svg') as string,
  IOS: require('../assets/apple-plain.svg') as string,
  JAVA: require('../assets/java-plain.svg') as string,
  JAVASCRIPT: require('../assets/javascript-plain.svg') as string,
  LINUX: require('../assets/linux-plain.svg') as string,
  PHP: require('../assets/php-plain.svg') as string,
  PYTHON: require('../assets/python-plain.svg') as string,
  R: require('../assets/r-plain.svg') as string,
  RUBY: require('../assets/ruby-plain.svg') as string,
  RUST: require('../assets/rust-plain.svg') as string,
  SCALA: require('../assets/scala-plain.svg') as string,
  SWIFT: require('../assets/swift-plain.svg') as string,
  TYPESCRIPT: require('../assets/typescript-plain.svg') as string,
  REACTJS: require('../assets/reactjs-plain.svg') as string,
  ANGULAR: require('../assets/angular-plain.svg') as string,
  VUE: require('../assets/vue-plain.svg') as string,
  NODE: require('../assets/nodejs-plain.svg') as string
} as any;

export const DevLogo = ({ id }: { id: string }) => {
  const Icon = Icons[id];
  return Icon ? <Icon /> : null;
};
